import { render } from "./App.vue?vue&type=template&id=4f898dbc"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=4f898dbc&lang=css"

import exportComponent from "/Volumes/P310_1T/workspace_cpp/slls_txt/slls-web-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__